/* import Vue from "vue";
import { colors } from '@/utils'; */

const initQueryParams = decodeURIComponent(location.search)
  .split("?")
  .join("")
  .split("&")
  .reduce((prev, curr) => {
    const s = curr.split("=");
    prev[s[0]] = s[1];
    return prev;
  }, {});
const defaultSearchTerm = initQueryParams.s || "";
const defaultCategories = (initQueryParams.c || "").split(",").filter((s) => s);

const defaultArticle = {
  articleVersions: [],
  authors: [],
  categories: [],
  content: "",
  deleted: false,
  pinned: false,
  klasses: [],
  publishedAt: 0,
  similarArticles: [],
  slug: "",
  snippet: "",
  title: "",
};

export default {
  state: {
    articles: [],
    zipFiles: [],
    searchTerm: defaultSearchTerm,
    didDisplayAllArticles: false,
    showCreateArticleList: false,
    selectedCategories: defaultCategories,
    categories: {},
    categoryColors: new WeakMap(),
    currentArticle: { ...defaultArticle },
    currentContentArea: "TextArea",
    createArticleSlugToLoad: "",
    forcedNewTitleAndSlug: { title: "", slug: "" },
    didReset: false,
    resetSearch: false,
    buttonAction: '',
    slugError: false,
    contentError: false,
    titleError: false,
    forcedNewSearch: undefined,
    isFetching: false,
    skip: 0,
    fetchNewArticles: {}
  },
  mutations: {
    nextPage(state) {
      state.skip = state.skip + 40;
      state.isFetching = true;
    },
    resetSkip(state) {
      state.skip = 0;
    },
    loadNextPage(state) {
      state.fetchNewArticles = {}
    },
    setCategories(state, value) {
      let hashMap = {};
      for (let category of value) {
        if (!hashMap[category.name]) hashMap[category.name] = category;
      }
      hashMap = Object.values(hashMap);
      // console.log(hashMap);
      state.categories = hashMap;
    },
    addCategory(state, value) {
      if (!state.selectedCategories.includes(value)) {
        state.selectedCategories.push(value);
      }
    },
    setSelectedCategories(state, value) {
      if (value.join("") != state.selectedCategories.join("")) {
        state.selectedCategories = [...new Set(value)];
      }
    },
    setDidDisplayAllArticles(state, value) {
      state.didDisplayAllArticles = value;
    },
    setCurrentContentArea(state, value) {
      state.currentContentArea = value;
    },
    setSlugError(state, value) {
      state.slugError = value;
    },
    setContentError(state, value) {
      state.contentError = value;
    },
    setTitleError(state, value) {
      state.titleError = value;
    },
    appendZipFile(state, value) {
      state.zipFiles.push(value);
    },
    resetZipFiles(state) {
      state.zipFiles = [];
    },
    setSearchTerm(state, value) {
      state.searchTerm = value;
      state.resetSearch = false;
    },
    resetSearch(state) {
      state.resetSearch = true;
      state.articles.length = 0;
      state.searchTerm = '';
    },
    appendArticles(state, value) {
      for (let v of value) {
        if (!state.articles.find((a) => a.id == v.id)) {
          state.articles.push(v);
        }
      }
    },
    setArticles(state, value) {
      state.articles = value;
    },
    setCurrentArticle(state, value) {
      if (value && value.klasses) {
        const k =
          value.klasses.find((k) => k.slug == this.getters.classNameInUrl) ||
          {};
        value.publishedAt = k.publishedAt || 0;
      }

      state.currentArticle = value;
    },
    resetCurrentArticle(state) {
      state.currentArticle = { ...defaultArticle };
      state.didReset = !state.didReset;
    },
    forceNewSearch(state, value = {}) {
      state.articles.length = 0;
      state.searchTerm = '';
      state.forcedNewSearch = value;
    },
    setButtonAction(state, value) {
      if (
        [
          "save",
          "saveDraft",
          "publish",
          "unpublish",
          "delete",
          "detach",
        ].includes(value)
      ) {
        state.buttonAction = value;
        setTimeout(() => {
          state.buttonAction = "";
        }, 0);
      }
    },
    setCreateArticleSlugToLoad(state, value) {
      state.createArticleSlugToLoad = value;
      setTimeout(() => {
        state.createArticleSlugToLoad = "";
      }, 100);
    },
    forceNewTitleAndSlug(state, value) {
      state.forcedNewTitleAndSlug = value;
      setTimeout(() => {
        state.forcedNewTitleAndSlug = "";
      }, 100);
    },
    toggleCreateArticleList(state, val) {
      state.showCreateArticleList = val;
    },
    setIsFetching(state, isFetching) {
      state.isFetching = isFetching
    }
  },
};
